import { useMutation, useQueryClient } from 'libs/query'
import { useNavigate } from 'libs/router'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { routes } from 'config/routes'
import { useTranslation } from 'react-i18next'
import { queryKeys } from 'config/queryKeys'

export const useAddBookingMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	const { mutate: addBookingMutation, isPending: addBookingLoading } = useMutation({
		// TODO: change to apiRoute
		mutationFn: (data: any) => axiosPrivate.post('/bookings/', data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.bookings.all })
			useToast({
				type: 'success',
				message: t('Booking added')
			})()
			navigate(routes.bookingIndex)
		},
		onError: (err: any) => {
			const data = err.response.data
			const nonFieldErrors = 'non_field_errors' in data ? data.non_field_errors : []
			const catchAllErrors = '__all__' in data ? data.__all__ : []
			const allErrors = [...nonFieldErrors, ...catchAllErrors]

			useToast({
				type: 'error',
				message: allErrors.join('\n') ?? t('Something went wrong')
			})()
		}
	})

	return {
		addBookingMutation,
		addBookingLoading
	}
}
